<!--<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">Navbar</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" [routerLink] = "['']" routerLinkActive = "active">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink] = "['login']" routerLinkActive = "active">Login</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink] = "['register']" routerLinkActive = "active" >Register</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink] = "['profile']" routerLinkActive = "active" >Profile</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink] = "['message']" routerLinkActive = "active" >Message</a>
      </li>
      
    </ul>
  </div>
</nav>-->

<router-outlet></router-outlet>
<ngx-spinner
size="medium"
color="#0866a9"
type="ball-clip-rotate">
<p style="font-size: 15px; color: #fff">Loading...</p>
</ngx-spinner> 